
import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface AssessmentNavigationProps {
  currentStep: number;
  totalSteps: number;
  canProceed: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export const AssessmentNavigation: React.FC<AssessmentNavigationProps> = ({
  currentStep,
  totalSteps,
  canProceed,
  onPrevious,
  onNext
}) => {
  console.log('🧭 [ASSESSMENT NAVIGATION] Render:', {
    currentStep,
    totalSteps,
    canProceed,
    isContactStep: currentStep === totalSteps - 2,
    shouldShowResults: currentStep === totalSteps - 2,
    shouldHideNavigation: currentStep === 0 || currentStep >= totalSteps - 1
  });

  // Hide navigation at intro (step 0), contact step (totalSteps - 2), and results (totalSteps - 1)
  if (currentStep === 0 || currentStep >= totalSteps - 2) {
    console.log('🚫 [ASSESSMENT NAVIGATION] Hidden - Intro, Contact or Results step');
    return null;
  }

  console.log('🎯 [ASSESSMENT NAVIGATION] Showing navigation for questionnaire steps');

  return (
    <div className="px-6 py-4 mt-2 border-t flex justify-between">
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={currentStep === 0}
        className="flex items-center gap-2 rounded-full"
      >
        <ChevronLeft className="h-4 w-4" />
        Précédent
      </Button>
      
      <button
        onClick={onNext}
        disabled={!canProceed}
        className={`flex items-center gap-2 ${canProceed ? 'nokodia-btn-cta-active' : 'nokodia-btn-cta-disabled'}`}
      >
        Suivant
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
};
